<template>
  <v-row justify="center" v-if="inscripcion">
    <v-dialog v-model="dialog" scrollable persistent max-width="600px">
      <v-card>
        <v-toolbar flat dark color="primary" class="max-height">
          <v-toolbar-title> Cambiar de Asesor </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog"> <v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" class="text-center" v-if="inscripcion.asesor">
              <!-- si existe asesor asignado mostrado aqui -->
              <p><strong> Asesor Actual </strong></p>
              <p>
                {{ inscripcion.asesor.num_doc }} - {{ inscripcion.asesor.nombres }} {{ inscripcion.asesor.pri_apellido }} {{ inscripcion.asesor.seg_apellido }}
              </p>
            </v-col>
            <v-col cols="12">
              <v-skeleton-loader :loading="!personal.length" transition="scale-transition" height="200" type="table">
                <v-data-table :headers="headers" :search="search" :items="personal" sort-by="index" :items-per-page="-1">
                  <template v-slot:top>
                    <v-text-field outlined dense v-model="search" label="Buscar en la lista" class="mx-4 mt-1"></v-text-field>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom>
                      <template #activator="{ on, attrs }">
                        <v-icon large class="ma-2" v-bind="attrs" v-on="on" color="success" @click="assignNewAsesor(item, inscripcion)"
                          >mdi-account-check</v-icon
                        >
                      </template>
                      Asignar Este Asesor al inscrito
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-skeleton-loader>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" outlined rounded @click="dialog = false"> Cerrar <v-icon> mdi-close</v-icon> </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import xaxios from '@/xaxios';
import gql from 'graphql-tag';
export default {
  data() {
    return {
      menu_name: process.env.VUE_APP_NAME_MENU,
      api_rest: process.env.VUE_APP_API_REST,

      headers: [
        { text: 'id', value: 'index' },
        { text: 'N° Documento', value: 'num_doc' },
        { text: 'Nombre Completo', value: 'full_name' },
        { text: 'Opciones', value: 'actions', sortable: false },
      ],
      dialog: false,
      search: '',
      inscripcion: null,
      personal: [],
    };
  },
  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
  },
  methods: {
    showThisView(ins) {
      this.dialog = true;
      this.inscripcion = ins;
      window.console.log('ins:',ins.asesor.id);
      if(!ins.asesor.id) ins.asesor.id = -1;
      this.getUsuarios(ins.asesor.id);
    },

    async assignNewAsesor(asesor, ins) {
      if (await this.$root.$confirm.open('Asignar Nuevo Asesor', 'estas seguro ??', { color: 'orange' })) {
        let userid = this.$store.state.DATA_USER.id;
        if(userid == 43){
          this.$root.$notify.show('Sin permiso para realizar esta accion', { color: 'red' });
          return;
        }
        
        const url = `${this.api_rest}/api/esam/inscripcion/change/asesor`;
        xaxios
          .post(url, { inscripcion_id: ins.id, asesor_id: asesor.id })
          .then(({ status }) => {
            if (status == 200) {
              this.$root.$notify.show('Asesor Asignado en el Sistema', { color: 'success' });
              this.$emit('updateIns', asesor);
            }
          })
          .catch(() => this.$root.$notify.show('No se puedo cambiar de asesor', { color: 'red' }));
        this.closeDialog();
      }
    },

    async getUsuarios(id) {
      let asesores = [];
      let users = await this.$apollo
        .query({
          query: gql`query{ getSede(id:${this.$store.state.CARGO.sede.id}){asesores_activos{usuario{id,estado,datos_personales{id,num_doc,nombres,pri_apellido,seg_apellido,email}}}}}`,
        })
        .then(
          ({
            data: {
              getSede: { asesores_activos },
            },
          }) => asesores_activos.filter((user) => user.usuario.estado)
        )
        .catch(() => this.$root.$notify.show(`Session Expirada`, { color: 'red' }));
      users = users.filter((user) => user.id != id);
      users.forEach(x=>{
        let ex = asesores.find(a=>a.usuario.id==x.usuario.id);
        if(!ex) asesores.push(x);
      });

      this.personal = asesores.map((user, i) => {
        user.index = i + 1;
        user.id = user.usuario.id;
        user.num_doc = user.usuario.datos_personales.num_doc;
        user.nombres = user.usuario.datos_personales.nombres;
        user.pri_apellido = user.usuario.datos_personales.pri_apellido;
        user.seg_apellido = user.usuario.datos_personales.seg_apellido;
        user.email = user.usuario.datos_personales.email;
        user.full_name = `${user.nombres} ${user.pri_apellido} ${user.seg_apellido}`;
        return user;
      });
    },

    closeDialog() {
      this.search = '';
      this.dialog = false;
      this.inscripcion = null;
      this.personal = [];
    },
  },
};
</script>
<style>
.max-height {
  max-height: 4.5em;
}
</style>